import { useCallback, useEffect, useRef, useState } from 'react';

/** Retained approved interaction from experiments/design-lab/react/useHoverPin.ts. */
export function useHoverPin(dismiss: () => void) {
  const [pinned, setPinned] = useState(false);
  const pinnedRef = useRef(false);
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  const enter = useCallback(() => clearTimeout(timer.current), []);
  const close = useCallback(() => {
    enter();
    pinnedRef.current = false;
    setPinned(false);
    dismiss();
  }, [dismiss, enter]);
  const closeUnlessPinned = useCallback(() => {
    if (!pinnedRef.current) close();
  }, [close]);
  const leave = useCallback(() => {
    enter();
    if (!pinnedRef.current) timer.current = setTimeout(closeUnlessPinned, 180);
  }, [enter, closeUnlessPinned]);
  const toggle = useCallback(() => {
    enter();
    pinnedRef.current = !pinnedRef.current;
    setPinned(pinnedRef.current);
  }, [enter]);
  useEffect(() => () => clearTimeout(timer.current), []);
  return { pinned, pinnedRef, enter, leave, toggle, close, closeUnlessPinned };
}
